import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bidi-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent  {
  @Input() resource;
  @Input() selected = false;
  @Input() themes = false;
  @Input() views = 0;
  @Input() dateSelect: any;
  @Input() noPublicator: any;
  @Output() resourceSelected = new EventEmitter<any>();
  @Output() newTheme = new EventEmitter<boolean>();
  noOpinions = false;
  showPreview = false;
  showPublicator = false;
  noCategory = 'Sin categorÃ­a';
  saveResource = false;

  openPreview() {
    this.showPreview = true;
  }

  openSelected() {
    if(this.noPublicator === true){
      this.openPreview()
    }
    else{    this.showPublicator = true;
      this.saveResource = true;}

  }

  closePreview(e) {
    this.showPreview = e;
  }

  closePublicator(e) {
    this.showPublicator = e;
  }

  selectResource(r) {
    this.resourceSelected.emit(r);
  }

  addTheme(e) {
    this.newTheme.emit(e);
  }

}
